import { Location } from '../../../shared/models/location';

export const DOHMH_ROLES: string[] = ['zzx1', 'zzx2', 'zzx3', 'zzx4', 'dhser'];
export const DOHMH_ALL_AGENCY_ROLES: string[] = ['zzx1', 'zzx2'];

 
export const DOHMH_ROLE_IDS: number[] = [1, 35, 36, 37, 38, 101];
export const DOHMH_ALL_AGENCY_ROLE_IDS: number[] = [35, 36];
export const DOHMH_NOT_SUPER_USER_IDS: number[] = [1, 37, 38, 101];
 

export const Service_Coordination: string = 'Service Coordinator';

export const DOHMH_ALL_AGENCY: Location = new Location({
  locationName: 'All Agencies',
  locationCode: 'ALL_AGENCY',
  locationKey: '0',
});
